import { ConfigProvider, Layout, Tabs, Button, Typography, Space, theme } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import keycloak from './keycloak';
import deDE from 'antd/locale/de_DE';
import StoresTab from './components/StoresTab';
import AddressesTab from './components/AddressesTab';
import ContactsTab from './components/ContactsTab';
import DeliverersTab from './components/DeliverersTab';
import './index.css';

const { Header, Content } = Layout;
const { Title } = Typography;

function MarkiseLogo({ size = 36 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <rect width="100" height="100" rx="16" fill="#a07838"/>
      <rect x="20" y="8" width="60" height="27" rx="2" fill="#b88840"/>
      <rect x="8" y="32" width="84" height="10" rx="3" fill="#f5ede0"/>
      <path d="M8,42 L92,42 L92,70 Q81.5,79 71,70 Q60.5,79 50,70 Q39.5,79 29,70 Q18.5,79 8,70 Z" fill="#ffffff"/>
      <defs>
        <clipPath id="markise-clip">
          <path d="M8,42 L92,42 L92,70 Q81.5,79 71,70 Q60.5,79 50,70 Q39.5,79 29,70 Q18.5,79 8,70 Z"/>
        </clipPath>
      </defs>
      <rect x="8"  y="42" width="14" height="37" fill="#e8c070" clipPath="url(#markise-clip)"/>
      <rect x="36" y="42" width="14" height="37" fill="#e8c070" clipPath="url(#markise-clip)"/>
      <rect x="64" y="42" width="14" height="37" fill="#e8c070" clipPath="url(#markise-clip)"/>
    </svg>
  );
}

export default function App() {
  const roles = keycloak.resourceAccess?.['fair-stores-app']?.roles || [];
  const isSupport = roles.includes('support');
  const isManager = roles.includes('manager');
  // buchhalter is primarily a fair-invoices-app role; see server/middleware/auth.js
  // for why it can also show up directly on this client's token.
  const isBuchhalter = roles.includes('buchhalter')
    || (keycloak.resourceAccess?.['fair-invoices-app']?.roles || []).includes('buchhalter');

  const tabs = [
    { key: 'stores',      label: 'Stores',      children: <StoresTab isSupport={isSupport} isBuchhalter={isBuchhalter} /> },
    { key: 'deliverers',  label: 'Lieferanten', children: <DeliverersTab isSupport={isSupport} /> },
    ...(isSupport ? [
      { key: 'addresses', label: 'Adressen',    children: <AddressesTab /> },
      { key: 'contacts',  label: 'Kontakte',    children: <ContactsTab /> },
    ] : []),
  ].filter(t => isSupport || isManager || isBuchhalter);

  return (
    <ConfigProvider
      locale={deDE}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary:       '#a07838',
          colorLink:          '#a07838',
          colorBgLayout:      '#f5ede0',
          colorBgContainer:   '#ffffff',
          colorBorder:        '#e8d5b0',
          colorTextSecondary: '#8a6a40',
          borderRadius:       6,
        },
      }}
    >
      <Layout style={{ minHeight: '100vh', background: '#f5ede0' }}>
        <Header style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '0 24px', background: '#7a5828',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <MarkiseLogo size={36} />
            <Title level={4} style={{ color: '#fff', margin: 0, lineHeight: 1 }}>Fair Stores</Title>
          </div>
          <Button ghost icon={<LogoutOutlined />} onClick={() => keycloak.logout()}
            style={{ borderColor: '#fff', color: '#fff' }}>
            Abmelden
          </Button>
        </Header>
        <Content style={{ padding: 24, maxWidth: 1400, margin: '0 auto', width: '100%' }}>
          <Tabs
            defaultActiveKey="stores"
            items={tabs}
            size="large"
            style={{
              background: '#ffffff', borderRadius: 8, padding: '0 16px 16px',
              border: '1px solid #e8d5b0',
            }}
          />
        </Content>
      </Layout>
    </ConfigProvider>
  );
}
